import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/new-request',
  redirect: '/new-request',
  name: 'NewRequestParent',
  component: Layout,
  meta: { title: 'new_request', root: true, auth: AUTH_KEYS.NEW_REQUEST },
  children: [
    {
      path: '/new-request',
      component: () => import('@/views/NewRequest/Index.vue'),
      meta: {
        title: 'new_request',
        auth: AUTH_KEYS.NEW_REQUEST_LIST,
        noBreadcrumb: true,
        isHide: true,
      },
    },
    {
      path: '/collection-request',
      meta: { title: 'collection_request', auth: AUTH_KEYS.COLLECTION_REQUEST, isHide: true },
      children: [
        {
          path: '/collection-request',
          component: () => import('@/views/CollectionRequest/Index.vue'),
          meta: { title: 'collection_request', auth: AUTH_KEYS.COLLECTION_REQUEST, isHide: true },
        },
        {
          path: '/collection-request/confirm',
          component: () => import('@/views/CollectionRequestConfirm/Index.vue'),
          meta: {
            title: 'collection_request_confirm',
            auth: AUTH_KEYS.COLLECTION_REQUEST_CONFIRM,
            isHide: true,
          },
        },
      ],
    },
    {
      path: '/new-quote-request',
      meta: { title: 'new_quote_req', auth: AUTH_KEYS.NEW_QUOTE_REQUEST, isHide: true },
      children: [
        {
          path: '/new-quote-request',
          name: 'QuoteRequest',
          component: () => import('@/views/NewRequest/QuoteRequest.vue'),
          meta: { title: 'new_quote_req', auth: AUTH_KEYS.NEW_QUOTE_REQUEST, isHide: true },
        },
        {
          path: '/new-quote-request/large-garbage',
          name: 'RegisterLargeGarbage',
          component: () => import('@/views/RegisterLargeGarbage/Index.vue'),
          meta: {
            title: 'large_garbage',
            auth: AUTH_KEYS.REGISTER_LARGE_GARBAGE,
            isHide: true,
          },
        },
        {
          path: '/new-quote-request/edit',
          meta: { title: 'large_garbage', auth: AUTH_KEYS.REGISTER_LARGE_GARBAGE, isHide: true },
          children: [
            {
              path: '/new-quote-request/edit',
              name: 'EditLargeGarbage',
              component: () => import('@/views/RegisterLargeGarbage/Edit.vue'),
              meta: {
                title: 'quotation_request_confirm',
                auth: AUTH_KEYS.QUOTATION_REQUEST_CONFIRM,
                isHide: true,
              },
            },
            {
              name: 'QuotationRequestConfirm',
              path: '/new-quote-request/quotation-request-confirm',
              component: () => import('@/views/QuotationRequestConfirm/Index.vue'),
              meta: {
                title: 'quotation_request_confirm',
                auth: AUTH_KEYS.QUOTATION_REQUEST_CONFIRM,
                isHide: true,
              },
            },
          ],
        },
        {
          path: '/new-quote-request/regular-garbage',
          name: 'RegisterRegularGarbage',
          component: () => import('@/views/RegisterRegularGarbage/Index.vue'),
          meta: {
            title: 'regular_garbage',
            auth: AUTH_KEYS.REGISTER_REGULAR_GARBAGE,
            isHide: true,
          },
        },
      ],
    },
  ],
};
